// assets
import { UsergroupAddOutlined, MedicineBoxOutlined } from '@ant-design/icons';
import OrgIcon from '../assets/static_images/org.svg';
// icons
const icons = {
    UsergroupAddOutlined,
    MedicineBoxOutlined
};
const children = [
    {
        id: 'organizationStructure',
        title: 'Organization Structure',
        type: 'collapse',
        url: '#',
        breadcrumbs: false,
        children: [
            {
                id: 'branch',
                title: 'Branch',
                type: 'item',
                url: '/dashboard/branch',
                breadcrumbs: false
            },
            {
                id: 'department',
                title: 'Department',
                type: 'item',
                url: '/dashboard/department',
                breadcrumbs: false
            },
            {
                id: 'departmentDivision',
                title: 'Division',
                type: 'item',
                url: '/dashboard/department-division',
                breadcrumbs: false
            },
            {
                id: 'job-title',
                title: 'Job Title',
                type: 'item',
                url: '/dashboard/job-title',
                breadcrumbs: false
            },
            {
                id: 'role',
                title: 'Role Permission',
                type: 'item',
                url: '/dashboard/roles',
                breadcrumbs: false
            }
        ]
    }
];
const OrganizationStructure = {
    id: 'organizationStructure',
    title: 'Organization Structure',
    type: 'group',
    icon: icons.MedicineBoxOutlined,
    children: children
};

export default OrganizationStructure;
